export const APPLICATION_ROLES = ["ADMIN", "ECOSTERN_BO_USER", "ECOSTERN_USER", "REGULAR_USER"] as const;
export type ApplicationRole = typeof APPLICATION_ROLES[number];
